<template>
    <div style="">
        <div style="margin:0 -12px;">
            <div class="luna-header-box">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-4">
                            <br>
                            <a :href="'/event/admin/mod/' + event_id">
                                <svg style="height:14px;width:14px;fill:#999;margin-top: -10px;">
                                    <use xlink:href="/images/<.svg#page_left"></use>
                                </svg>
                            </a>
                        </div>
                        <div class="col px-0 text-center">
                            <div style="padding-top:20px; ">
                                <b>イベントを削除</b>
                            </div>
                        </div>
                        <div class="col-4 text-end">
                        </div>
                    </div>
                </div>
            </div>
            <div class="wrap">
                <div class="container" style="margin-top:60px;">
                    <div class="row" style="">
                        <div class="col">
                            <div class="text-center" style="padding:20px 0;font-size:18px;color:#000">
                                すべての情報は削除されます<br>
                                よろしいですか？
                            </div>
                            <div>
                                <div class="row justify-content-center">
                                    <div class="col-8">
                                        <div class="d-grid gap-2">
                                            <a type="button" class="btn btn-danger" @click="rmEvent()"
                                                style="padding:12px 0;border-radius: 50px;">
                                                削除する
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            event_id: ""
        };
    },
    methods: {
        async isAuth() {
            await axios.get("/api/auth/user/get")
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    }
                })
        },
        async rmEvent() {
            await axios.get("/api/event/rm/" + this.event_id)
                .then(
                    (response) => {
                        window.location.href = "/event/home"
                    }
                )
                .catch((error) => {
                    if (error.response && error.response.status == 401) {
                        window.location.href = "/auth?logout=true"
                    }
                    else {
                        this.$showErrorToast("イベントの削除に失敗しました")
                    }
                })
        },
    },
    async created() {

        // 自動ログインチェック
        var arr = new Array();
        if (document.cookie != '') {
            var tmp = document.cookie.split('; ');
            for (var i = 0; i < tmp.length; i++) {
                var data = tmp[i].split('=');
                arr[data[0]] = decodeURIComponent(data[1]);
            }

            if (arr['uid'] != undefined) {
                await axios.get("/api/user/auth/" + arr['uid'])
                    .then(
                        (response) => {
                            this.isAuth()
                            this.event_id = this.$route.params['eid']
                        })
                    .catch((error) => {
                        this.$showErrorToast("ユーザーの取得に失敗しました")
                    })
            }
            else {
                this.isAuth()
                this.event_id = this.$route.params['eid']
            }
        }
        else {
            this.isAuth()
            this.event_id = this.$route.params['eid']
        }
    },
}
</script>
<style scoped>
.footer_event_after_box {
    background-color: #cdcdcd;
    color: #999;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_befor_box {
    background-color: #C6C4FF;
    color: #6B4EFF;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.footer_event_now_box {
    background-color: #6B4EFF;
    color: #fff;
    font-size: 14px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.luna-header-box {
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.1);
    height: 56px;
    width: 540px;
    background-color: #fff;
    z-index: 999;
}


@media (max-width: 576px) {
    .luna-header-box {
        width: 100%;
    }
}
</style>
